/**
 * supportApi.ts - endpoints de support (formulaire de contact + tickets du client).
 */
import { apiFetch } from './apiClient';

export type SupportCategory =
  | 'technical' | 'bug' | 'compliance' | 'billing' | 'feature' | 'other';

export type SupportLanguage = 'fr-BE' | 'nl-BE' | 'de-BE' | 'en';

export type SupportTicketStatus = 'open' | 'in_progress' | 'resolved' | 'closed' | string;

export interface SupportTicketInput {
  category:    SupportCategory;
  email:       string;
  name?:       string;
  phone?:      string;
  language:    SupportLanguage;
  description: string;
  attachmentUrl?:  string;
  attachmentName?: string;
}

export interface SupportTicketResponse {
  ticketId: string;
  sla:      string;
  message:  string;
}

export interface SupportAttachmentSas {
  uploadUrl: string;
  readUrl:   string;
  blobName:  string;
  filename:  string;
}

export interface SupportTicket {
  id:              string;
  category:        SupportCategory;
  status:          SupportTicketStatus;
  description:     string;
  email:           string;
  name?:           string;
  phone?:          string;
  language:        SupportLanguage;
  sla?:            string;
  attachmentUrl?:  string;
  attachmentName?: string;
  createdAt:       string;
}

export const supportApi = {
  createTicket: (input: SupportTicketInput) =>
    apiFetch<SupportTicketResponse>('/support/ticket', {
      method: 'POST',
      body:   JSON.stringify(input),
      headers: { 'Content-Type': 'application/json' },
    }),

  getAttachmentSas: (filename: string) =>
    apiFetch<SupportAttachmentSas>('/support/attachment-sas', {
      method: 'POST',
      body:   JSON.stringify({ filename }),
      headers: { 'Content-Type': 'application/json' },
    }),

  listMyTickets: () =>
    apiFetch<{ tickets: SupportTicket[] }>('/support/tickets'),

  closeTicket: (id: string) =>
    apiFetch<{ closed: boolean; status: string }>(`/support/tickets/${encodeURIComponent(id)}/close`, {
      method: 'POST',
    }),
};
